<template>
  <li v-if="dark_mode" id="darkmode_btn" class="btn nav-link" role="button" @click="updateDarkMode()">
    <i class="fa fa fa-moon"></i>
    Dark Mode
  </li>
  <li v-else id="darkmode_btn" class="btn nav-link" role="button" @click="updateDarkMode()">
    <i class="fa fa-regular fa-sun"></i>
    White Mode
  </li>
</template>

<script>
import wppController from "../controller/wppController";
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  mixins: [wppController, sweetAlert, Swal],

  props: ["user"],

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      dark_mode: false,
    };
  },

  mounted() {
    if (this.user.dark_mode == 1) {
      this.dark_mode = false;
    }
  },

  methods: {
    updateDarkMode() {

      console.log(document.body.value);

      this.isLoading = true;

      let data = {};

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`admin/darkmode`, data)
        .then((response) => {
          this.dark_mode = !this.dark_mode;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}
</style>
